/* import __COLOCATED_TEMPLATE__ from './edge.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import Component from '@glimmer/component';

import type Edge from '../../models/graph-editor/edge';
import Coordinates from '../../models/graph-editor/coordinates';

interface Args {
  edge: Edge;
}
export default class GraphEditorEdgeComponent extends Component<Args> {
  @tracked isShowingClickPoint = false;
  @tracked clickPointCoordinates: Coordinates = new Coordinates(0, 0);
  clickPointElement?: HTMLElement;

  @action setClickPointElement(element: HTMLElement): void {
    this.clickPointElement = element;
  }

  @action onClick(): void {
    if (this.args.edge.graph.hooks.canSelectEdge(this.args.edge)) {
      this.openClickPoint();
      this.args.edge.graph.edges.removeObject(this.args.edge);
      this.args.edge.graph.edges.pushObject(this.args.edge);
      this.args.edge.graph.state.selectedEdge = this.args.edge;
    }
  }

  @action onMouseEnter(): void {
    this.args.edge.graph.state.setMouseAtEdge(this.args.edge);
  }

  @action onMouseLeave(): void {
    this.args.edge.graph.state.removeMouseFromEdge();
  }

  private openClickPoint(): void {
    if (!this.isShowingClickPoint) {
      this.clickPointCoordinates = new Coordinates(
        this.args.edge.graph.state.mouseCoordinates.x,
        this.args.edge.graph.state.mouseCoordinates.y,
      );
      this.isShowingClickPoint = true;
      document.addEventListener('click', this.closeClickPoint);
    }
  }

  @action closeClickPoint(event: MouseEvent): void {
    if (this.clickPointElement) {
      let target = (event.target as Node) || document.getRootNode();
      if (!this.clickPointElement.contains(target) && target !== this.args.edge.element) {
        this.isShowingClickPoint = false;
        document.removeEventListener('click', this.closeClickPoint);
      }
    }
  }

  willDestroy() {
    super.willDestroy();
    document.removeEventListener('click', this.closeClickPoint);
  }
}
